import {useI18n} from '@yandex-delivery/core/i18n'
import {Typography} from '@yandex-delivery/ui'

import {Paper} from '../../../../../components/ui'
import {type CitiesListProps, CitiesList} from '../cities-list'
import styleClasses from './classes@desktop.module.css'

export function CitiesListContainer(props: CitiesListProps) {
  const i18n = useI18n()

  return (
    <Paper className={styleClasses.citiesListContainer}>
      <Typography className={styleClasses.citiesListTitle} density="tight" level="title4" weight="medium">
        {i18n('tariffs-v3.cities-list.title', 'Выберите город')}
      </Typography>
      <CitiesList {...props} />
    </Paper>
  )
}
